const PreviousYearsIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.6667 16V12.6667C26.6667 11.7238 26.6667 11.2524 26.3738 10.9595C26.0809 10.6667 25.6095 10.6667 24.6667 10.6667H18.9902C18.1727 10.6667 17.7639 10.6667 17.3964 10.5144C17.0289 10.3622 16.7398 10.0731 16.1618 9.49509L14.5049 7.83823C13.9269 7.26017 13.6378 6.97114 13.2703 6.8189C12.9027 6.66666 12.494 6.66666 11.6765 6.66666H9.33334C7.44773 6.66666 6.50492 6.66666 5.91913 7.25244C5.33334 7.83823 5.33334 8.78104 5.33334 10.6667V21.3333C5.33334 23.2189 5.33334 24.1618 5.91913 24.7475C6.50492 25.3333 7.44773 25.3333 9.33334 25.3333H14.6667"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="20.6667" cy="20.6667" r="3.33333" stroke="#3D3A62" strokeWidth="2" />
    <path
      d="M24.6667 24.6667L26.6667 26.6667"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default PreviousYearsIcon;
